/* @flow */
import SchoolViewSection from './SchoolViewSection';

export default SchoolViewSection;
